<template>
  <b-container>
    <b-card class="mt-3" style="margin-bottom:100px;">
      <app-head />
      <b-row>
        <b-col>
          <app-datenschutz />
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
// @ is an alias to /src
import Datenschutz from "@/components/Datenschutz.vue";
import Head from "@/components/Head.vue";

export default {
  name: "Impressum",
  components: {
    appDatenschutz: Datenschutz,
    appHead: Head,
  },
};
</script>
